import React from 'react';

export const ServiceTypeSelect = ({ handleChange, formData }) => {
    return (
        <div className='p-4 border border-gray-300 rounded-lg grid grid-cols-1 gap-2 '>
            <h5 className='font-semibold md:col-span-2'>Servicetype: {formData.servicetype}</h5>

            <select
                onChange={handleChange}
                value={formData.servicetype}
                name='servicetype'
                className='mt-1 block w-full p-2 border border-gray-300 rounded-md'
            >
                <option value='Sykkelservice'>Sykkelservice</option>
                <option value='Skiservice'>Skiservice</option>
                <option value='Skøyteslip'>Skøyteslip</option>
                <option value='Tekstiltrykking'>Tekstiltrykking</option>
            </select>
        </div>
    );
};
